import React from 'react';
import { Trans } from 'react-i18next';

import MilestoneContainer from '../containers/milestone-container';
import TaskGroupName from './task-group-name';

const Name = ({ name = null, task_group, removed }) => {
    if (removed) {
        return <React.Fragment>(<Trans i18nKey="milestone:Removed Milestone" />)</React.Fragment>;
    }

    if (task_group) {
        return <TaskGroupName id={task_group} />;
    }

    return name;
};

const MilestoneName = ({ id }) => <MilestoneContainer id={id}><Name /></MilestoneContainer>;

export default MilestoneName;
